import React from 'react';

import Metadata from '@pray/shared/components/Metadata';

import { Paragraph } from 'components/pages/public/components/icons/features';
import { PRODUCT_LABELS, Products } from 'components/pages/public/types/products';
import { VIEW_EVENT_NAMES } from 'constants.js';

import { Header } from '../../../../components/Header/Header';
import ProductPageLayout from '../../layout/ProductPageLayout';

const ContentManagementPage: React.FC = () => {
  return (
    <div data-viewname={VIEW_EVENT_NAMES.PRODUCTS.CMS}>
      <Metadata
        title={`${PRODUCT_LABELS[Products.CMS]} for Ministries: Sermon & Content Management | ${
          PRODUCT_LABELS[Products.PRAYSTUDIO]
        }`}
        description={`Simplify how your ministry manages sermons, media, and resources. ${
          PRODUCT_LABELS[Products.PRAYSTUDIO]
        } ${PRODUCT_LABELS[Products.CMS]} gives ministry leaders tools to organize, share, and inspire.`}
      />
      <Header />
      <ProductPageLayout
        // Hero section
        tag={PRODUCT_LABELS[Products.CMS]}
        icon={<Paragraph />}
        title="Use AI to Organize, Search, and Create Your Content"
        description={`${
          PRODUCT_LABELS[Products.PRAYSTUDIO]
        } transforms the way pastors and church leaders prepare, store, and access their content, giving you total control with effortless organization and instant retrieval.`}
        ctaText="GET STARTED"
        heroMedia={{ type: 'image', src: 'https://d339bgihw9yfmi.cloudfront.net/web/images/cms-hero.png' }}
        // Benefits section
        benefitsSectionTitle={`Why ${PRODUCT_LABELS[Products.CMS]}?`}
        benefits={[]}
        // How it works section
        howItWorksSectionTitle=""
        steps={[
          {
            tag: 'LEAD WITH PURPOSE',
            title: 'Your Teachings, Unified',
            description: `Focus on ministry, not management. ${
              PRODUCT_LABELS[Products.PRAYSTUDIO]
            } organizes sermons, prayers, and teachings in one trusted space, so you can build God's kingdom with clarity and purpose.`,
            buttonText: 'GET STARTED',
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/cms-benefit-step-1.png',
            imageAlt: 'Your Teachings Unified',
          },
        ]}
        // Solution cards section
        solutionsSectionTitle="All-in-one Solution"
      />
    </div>
  );
};

export default ContentManagementPage;
